import React, { useState } from "react";
import { Col, Row, Space } from "antd";
import {
  ThemeButton,
  ThemeCard,
  ThemeForm,
  ThemeInput,
  ThemeTitle,
} from "../../Styles/Theme";
import { PlusOutlined } from "@ant-design/icons";
import { ThemeQstName } from "../SurveyComponents/QstFormat/QstStyle";
import Header from "../../../Components/Header/Header";
import MobHeader from "../../../Components/Header/MobHeader";

const Share = () => {
  const [activeTab, setActiveTab] = useState(0); // 0 for first button, 1 for second, 2 for third

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <>
      <Header />
      <MobHeader />
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <ThemeButton
            className={`fullWidth noRadius ${
              activeTab === 0 ? "" : "noBackground "
            }`}
            size="large"
            shape="square"
            icon={<PlusOutlined />}
            iconPosition="end"
            onClick={() => handleTabClick(0)}
          >
            <Space>
              <img src="/images/email-icon.svg" alt="Share via Email" />
              Share via Email
            </Space>
          </ThemeButton>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <ThemeButton
            className={`fullWidth noRadius ${
              activeTab === 1 ? "" : "noBackground"
            }`}
            size="large"
            shape="square"
            icon={<PlusOutlined />}
            iconPosition="end"
            onClick={() => handleTabClick(1)}
          >
            <Space>
              <img src="/images/attach-icon.svg" alt="Share via Email" />
              Share a Link
            </Space>
          </ThemeButton>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <ThemeButton
            className={`fullWidth noRadius ${
              activeTab === 2 ? "" : "noBackground"
            }`}
            size="large"
            shape="square"
            icon={<PlusOutlined />}
            iconPosition="end"
            onClick={() => handleTabClick(2)}
          >
            <Space>
              <img src="/images/attach-icon.svg" alt="Share via Email" />
              Call AI John Della Volpe
            </Space>
          </ThemeButton>
        </Col>
      </Row>
      <ThemeCard className="mt-6 grayBackground">
        <ThemeForm layout="vertical">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <ThemeTitle className="mb-4">Edit Study Message</ThemeTitle>
              <div className="bg-white p-3 rounded-md">
                <ThemeQstName className="">
                  Who should take the lead in addressing climate change?
                </ThemeQstName>
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className="bg-white p-3 rounded-md">
                <ThemeQstName className="">
                  Thank you for participating in this important research
                  project. Please note that everything shared is confidential,
                  all viewpoints are respected, and there are no right or wrong
                  answers. This is an open conversation that should not last
                  more than 10 minutes. On the next page, you will see phone
                  numbers for different cities and a PIN number. Call the number
                  for your city and enter the PIN (by voice) to begin the
                  interview. Please click 'Next' to start the interview.
                </ThemeQstName>
              </div>
            </Col>
            {activeTab === 0 ? (
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={6}>
                    <ThemeForm.Item label="Email ID" name="emailId">
                      <ThemeInput size="large" placeholder="Enter Email ID" />
                    </ThemeForm.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <ThemeForm.Item label="Your PIN" name="pin">
                      <ThemeInput
                        size="large"
                        disabled
                        value="429369"
                        placeholder="429369"
                      />
                    </ThemeForm.Item>
                  </Col>
                </Row>
              </Col>
            ) : null}
            {activeTab === 1 ? (
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={6}>
                    <ThemeForm.Item label="Link" name="link">
                      <ThemeInput size="large" placeholder="Enter link here" />
                    </ThemeForm.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <ThemeForm.Item label="Your PIN" name="pin">
                      <ThemeInput
                        size="large"
                        disabled
                        value="368574"
                        placeholder="368574"
                      />
                    </ThemeForm.Item>
                  </Col>
                </Row>
              </Col>
            ) : null}
            {activeTab === 2 ? (
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={6}>
                    <ThemeForm.Item label="Your PIN" name="pin">
                      <ThemeInput
                        size="large"
                        value="589601"
                        disabled
                        placeholder="589601"
                      />
                    </ThemeForm.Item>
                  </Col>
                </Row>
              </Col>
            ) : null}
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-end">
              <ThemeButton size="large">Save</ThemeButton>
            </Col>
          </Row>
        </ThemeForm>
      </ThemeCard>
    </>
  );
};

export default Share;
